import {
  ES_CASE_NOTE_ADD_NEW,
  ES_CASE_NOTE_ADD_NEW_SUCCESS,
  ES_CASE_NOTE_ADD_NEW_ERROR,
  ES_CASE_NOTE_DELETE,
  ES_CASE_NOTE_DELETE_ERROR,
  ES_CASE_NOTE_DELETE_SUCCESS,
  ES_CASE_NOTE_EDIT,
  ES_CASE_NOTE_EDIT_ERROR,
  ES_CASE_NOTE_EDIT_SUCCESS,
  ES_CASE_NOTE_GET_BY_ID,
  ES_CASE_NOTE_GET_BY_ID_ERROR,
  ES_CASE_NOTE_GET_BY_ID_SUCCESS,
  ES_CASE_NOTE_GET_LIST,
  ES_CASE_NOTE_GET_LIST_ERROR,
  ES_CASE_NOTE_GET_LIST_SUCCESS,
  ES_CASE_NOTE_ADD_NEW_REQUEST,
  ES_CASE_NOTE_QUERY,
  ES_CASE_NOTE_QUERY_SUCCESS,
  ES_CASE_NOTE_QUERY_ERROR,
} from '../actions';

const initialState = {
  caseNotes: [],
  caseNote: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ES_CASE_NOTE_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case ES_CASE_NOTE_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNote: payload,
      };

    case ES_CASE_NOTE_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case ES_CASE_NOTE_QUERY:
    case ES_CASE_NOTE_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case ES_CASE_NOTE_QUERY_SUCCESS:
    case ES_CASE_NOTE_GET_LIST_SUCCESS:
      return {
        ...state,
        caseNotes: payload,
        loading: true,
      };
    case ES_CASE_NOTE_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case ES_CASE_NOTE_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNote: payload,
        caseNotes: state.caseNotes.concat(payload),
        addSuccess: true,
      };

    case ES_CASE_NOTE_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case ES_CASE_NOTE_EDIT_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNotes: state.caseNotes.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        caseNote: payload,
        error: null,
        editSuccess: true,
      };
    case ES_CASE_NOTE_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case ES_CASE_NOTE_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNotes: state.caseNotes.filter(c => c.id !== payload),
        deleteSuccess: true,
      };
    case ES_CASE_NOTE_QUERY_ERROR:
    case ES_CASE_NOTE_DELETE_ERROR:
    case ES_CASE_NOTE_ADD_NEW_ERROR:
    case ES_CASE_NOTE_EDIT_ERROR:
    case ES_CASE_NOTE_GET_BY_ID_ERROR:
    case ES_CASE_NOTE_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
